export default __webpack_public_path__ + "static/media/team_profile.3816212e.png";